import styled from '@emotion/styled';

export const ParentRoot = styled('div', {
  shouldForwardProp: (prop) => !['isManagerRouteActivated'].includes(prop),
})`
  height: 100%;

  ${({ isManagerRouteActivated }) => isManagerRouteActivated && `
    box-sizing: border-box;
    transition: all 0.5s ease-out;
    width: auto;
    padding: 0;
  `}
`;

export const NotAuthorized = styled('img')`
  display: block;
  margin: 0 auto;
`;

export const RouteContent = styled('div', {
  shouldForwardProp: (prop) => !['readOnly', 'isManagerRouteActivated'].includes(prop),
})`
  display: flex;
  flex-direction: column;
  height: 100%;

  ${({ readOnly }) => readOnly && `
    pointer-events: none;
    cursor: not-allowed;
    opacity: 0.5;
  `}

  ${({ isManagerRouteActivated }) => isManagerRouteActivated && `
    height: 100%;
    padding-bottom: 0;
  `}
`;

export const LockedAccountImageParent = styled('div')`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 70px;
`;

export const LockedAccountImage = styled('img')`
  width: 420px;
  height: 275px;

  @media screen and (max-width: 1180px) {
    width: 257px;
    height: 174px;
  }
`;

export const LockedAccountFirstTextParent = styled('div')`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 40px;
`;

export const LockedAccountFirstText = styled('div')`
  width: 100%;
  padding: 0 35px;
  font-size: 48px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  text-align: center;
  color: rgba(45, 58, 71, 1);
  margin-block-start: 10px;
  margin-block-end: 10px;

  @media screen and (max-width: 1180px) {
    font-size: 35px;
  }
`;

export const LockedAccountSecondTextParent = styled('div')`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 25px;
`;

export const LockedAccountSecondText = styled('div')`
  width: 100%;
  padding: 0 35px;
  font-size: 18px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  text-align: center;
  color: rgba(45, 58, 71, 1);

  @media screen and (max-width: 1180px) {
    font-size: 15px;
  }
`;

export const LockedAccountThirdText = styled('div')`
  width: 560px;
  padding: 0 35px;
  font-size: 18px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  text-align: center;
  color: rgba(45, 58, 71, 0.7);

  @media screen and (max-width: 1180px) {
    font-size: 15px;
  }
`;

export const LockedAccountLastTextParent = styled('div')`
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const LockedAccountFourthText = styled('div')`
  width: 100%;
  padding: 0 35px;
  font-size: 18px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  text-align: center;
  color: rgba(45, 58, 71, 1);
  margin-bottom: 30px;

  @media screen and (max-width: 1180px) {
    font-size: 15px;
  }
`;
